import { ChangeDetectionStrategy, Component, Input, ViewChild } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ToastService } from '@vsolv/vectors-ui/alert';
import { DialogComponent } from '@vsolv/vectors-ui/dialog';
import { Policy } from '@wsphere/warranties/domain';
import { PolicyService } from '../../services';

@Component({
  changeDetection: ChangeDetectionStrategy.Eager,
  selector: 'ws-create-new-version-dialog',
  templateUrl: './create-new-version.dialog.html',
  standalone: false,
})
export class CreateNewVersionDialog {
  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private policySvc: PolicyService,
    private toastSvc: ToastService
  ) {}
  @ViewChild(DialogComponent) dialog!: DialogComponent;

  @Input() policy?: Policy.Model | null;
  @Input() plan?: Policy.Plan.Model | null;

  saving = false;

  open() {
    this.dialog.open();
  }

  close() {
    this.dialog.close();
  }

  async createNewVersion() {
    if (this.saving) return;
    if (!this.policy || !this.plan) return;

    this.saving = true;

    const newVersion = await this.policySvc.duplicate(this.policy.id, true).catch(({ error }) => {
      this.toastSvc.show({
        type: 'error',
        title: 'Something went wrong',
        text: error.message,
      });
    });

    const newVersionObj =
      newVersion && typeof newVersion === 'object'
        ? (newVersion as { id: string; plans?: { id: string }[] })
        : undefined;
    const newVersionId = newVersionObj?.id;
    if (newVersionId && newVersionObj) {
      this.toastSvc.show({
        type: 'success',
        title: 'Updated plan',
        text:
          'A new version of <strong>' +
          this.policy.title +
          '</strong> has been created with an updated version of <strong>' +
          this.plan.title +
          '</strong>.',
      });

      const newPlan = newVersionObj.plans?.find(plan => plan.id.startsWith(this.plan?.id?.split('-')[0] || ''));
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      if (newPlan) this.policySvc.setPlan(newPlan as any);
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      this.policySvc.setPolicy(newVersionObj as any);

      const target = '/policies/' + newVersionId + '/plans/' + newPlan?.id;
      await this.navigateTo(target);
    }

    this.saving = false;
    this.close();
  }

  navigateTo(path?: string) {
    if (path) return this.router.navigate([`${path}`]);
    return Promise.resolve(false);
  }
}
